<template>
    <div>
        <vue-slider
            :tooltip="'always'"
            :tooltip-style="{ 
                'border-color': '#34A34E',
                'background-color': '#34A34E',
                'font-weight': 'bold',
                'letter-spacing': '0.25px',
                'height': '24px',
                'line-height': '23px',
                'padding-left': '10px',
                'padding-right': '10px',
            }"
            class="Slider" ref="slider" v-bind="slider"
            :value="sliderValue"
            @change="$emit('sliderChange', $refs.slider.getValue())">

        </vue-slider>
        <div v-if="(custom)">
            <div class="Slider__custominput"><label>Number:</label>
                <div class="Slider__inputwrapper">
                    <input
                        type="text"
                        ref="customValue"
                        :placeholder="this.placeholder"
                        :value="customValue"
                        @input="$emit('customChange', $event.target.value)"
                    >
                    <button
                        :disabled="isButtonDisabled"
                        class="btn"
                        @click="nextQuestion()"
                    >
                        {{ ( next == "results" ? "Results" : "Next" ) }}
                    </button>

                    <p>This value needs to be above {{ this.numberMax }}</p>
                </div>
            </div>
        </div>
        <div v-if="(!custom)">
            <next-button v-bind="{
                next
            }" ></next-button>
        </div>
    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component';
    import 'vue-slider-component/theme/default.css';
    import NextButton from '../buttons/NextButton.vue';

    export default {
        name: "MoneySlider",
        components: {
            VueSlider,
            NextButton
        },
        props: {
            min: Number,
            max: Number,
            step: Number,
            tick: Number,
            format: String,
            next: [String, Number],
            useCustom: Boolean,
            sliderValue: [String, Number, Boolean],
            customValue: [String, Number, Boolean],
            isButtonDisabled: Boolean,
            ariaLabel: String
        },
        methods: {
            nextQuestion: function() {
                if (this.next == "results") {
                    $router.push(this.next);
                } else {
                    this.$store.commit('update', { name: 'previous', value: this.key });
                    this.$store.commit('update', { name: 'step', value: this.next });
                }
            }
        },
        computed: {
            numberMax() { return this.max},
            placeholder() { return 'e.g. ' + (this.max+1)},
            custom: function() {
                if (this.sliderValue >= this.max) {
                    return true;
                } else if (this.useCustom) {
                    return true;
                } else {
                    return false;
                }
            },
            slider() {
                return {
                    dotSize: 25,
                    width: 'auto',
                    height: 4,
                    contained: false,
                    direction: 'ltr',
                    data: null,
                    min: this.min,
                    max: this.max,
                    interval: this.step,
                    disabled: false,
                    clickable: true,
                    duration: 0.5,
                    adsorb: false,
                    lazy: true,
                    tooltip: 'focus',
                    tooltipPlacement: 'top',
                    useKeyboard: true,
                    enableCross: true,
                    fixed: false,
                    minRange: void 0,
                    maxRange: void 0,
                    order: true,
                    marks: val => {
                        if (val === this.max) {
                            return {label: `over ${val}`};
                        } else if (val % this.tick === 0) {
                            return {label: `${val}`};
                        } else {
                            return false;
                        }
                    },
                    dotOptions: {
                        focusStyle: { border: '3px solid #FCC52E', boxShadow: 'none' }
                    },
                    dotAttrs: {
                        'aria-label': this.ariaLabel.replace('<br>', '')
                    },
                    process: true,
                    railStyle: void 0,
                    dotStyle: { backgroundColor: '#34A34E' },
                    processStyle: { backgroundColor: '#34A34E' },
                    tooltipStyle: { backgroundColor: '#34A34E' },
                    stepStyle: void 0,
                    stepActiveStyle: void 0,
                    labelStyle: {
                        marginTop: '1em',
                        lineHeight: '1.5em',
                    },
                    labelActiveStyle: void 0,
                }
            }
        }
    };
</script>
